var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6626 1.23152C11.9718 0.922826 12.4731 0.922826 12.7823 1.23152L15.7681 4.21254C15.9166 4.36078 16 4.56184 16 4.77148C16 4.98113 15.9166 5.18218 15.7681 5.33042L12.7823 8.31145C12.4731 8.62014 11.9718 8.62014 11.6626 8.31145C11.3534 8.00275 11.3534 7.50226 11.6626 7.19356L13.2969 5.56188L5.88852 5.56163C5.45125 5.56161 5.09679 5.2077 5.09681 4.77114C5.09682 4.33458 5.45131 3.98069 5.88857 3.9807L13.2968 3.98096L11.6626 2.3494C11.3534 2.04071 11.3534 1.54022 11.6626 1.23152ZM4.33741 7.55522C4.6466 7.86392 4.6466 8.36441 4.33741 8.6731L2.65764 10.3502H10.3676C10.8049 10.3502 11.1593 10.7041 11.1593 11.1406C11.1593 11.5772 10.8049 11.9311 10.3676 11.9311H2.74868L4.33741 13.5173C4.6466 13.826 4.6466 14.3265 4.33741 14.6351C4.02821 14.9438 3.52691 14.9438 3.21772 14.6351L0.231894 11.6541C-0.0772981 11.3454 -0.0772981 10.8449 0.231894 10.5362L3.21772 7.55522C3.52691 7.24653 4.02821 7.24653 4.33741 7.55522Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnExchange);
export default __webpack_public_path__ + "static/media/icn-exchange.54e4d830e1e37fcf8e743d3594012745.svg";
export { ForwardRef as ReactComponent };